(function() {
  'use strict';

  angular
    .module('NozzleSelector.controllers')
    .controller('SelectorCtrl', selectorController);

  /* @ngInject */
  function selectorController($state, $translate, $timeout, $localStorage, dataService) {
    var vm = this;

    // functions
    vm.reset = reset;
    vm.setAppRateUnit = setAppRateUnit;
    vm.setSpeedUnit = setSpeedUnit;
    vm.calculateFlowRate = calculateFlowRate;
    vm.showResults = showResults;
    vm.goBack = goBack;
    vm.dismissWarning = dismissWarning;
    vm.generateEmailTemplate = generateEmailTemplate;
    vm.spacingViewValue = '20in / 50cm';

    vm.initial = true;
    console.log('selector controller loaded');
    if (vm.initial && !vm.calculated) { reset(); }

    // Set initial defaults
    function reset() {
      console.log('-- Reset --');

      vm.query = {};

      // flags
      vm.next = false;
      vm.driftControl = true;
      vm.mode = null;
      vm.calculated = false;
      vm.useMetricFormula = false;
      vm.disableResults = false;
      vm.changePreferences = false;
      vm.initial = false;
      vm.noemail = {
        warn: true,
        flag: $localStorage.warned || false,
        error: false
      };

      // get data
      vm.units = dataService.getUnits();
      vm.filters = dataService.getFilters();
      vm.nozzles =  dataService.getNozzles();

      // select units
      vm.appRate =  vm.units.applicationRate[$localStorage.arIndex || 0];
      vm.groundSpeed = vm.units.groundSpeed[$localStorage.gsIndex || 0];

      // Set default units
      vm.query = {
        appRate: vm.appRate,
        groundSpeed: vm.groundSpeed,
        mode: vm.mode,
        dc: vm.driftControl
      };

      // but delete the values
      vm.query.appRate.value = null;
      vm.query.groundSpeed.value = null;
    }

    function setAppRateUnit() {
      vm.calculated = false;
      vm.query.appRate.value = null;

      var appRateIndex = 0;
      vm.units.applicationRate.forEach(function(ar, index) {
        if (ar.abbr === vm.appRate.abbr) {
          appRateIndex = index;
          vm.query.appRate = ar;
        }
      });

      vm.appRate = vm.query.appRate;
      $localStorage.arIndex = appRateIndex;
    }

    function setSpeedUnit() {
      vm.calculated = false;
      vm.query.groundSpeed.value = null;
      var groundSpeedIndex = vm.groundSpeed.abbr === 'Km/h' ? 1 : 0;
      vm.query.groundSpeed = vm.units.groundSpeed[groundSpeedIndex];

      vm.groundSpeed = vm.query.groundSpeed;
      $localStorage.gsIndex = groundSpeedIndex;
    }

    function calculateFlowRate(scope) {
      if (scope.selectorOptions.appRate.$valid && scope.selectorOptions.groundSpeed.$valid) {

        vm.useMetricFormula = vm.query.appRate.isMetric;
        vm.query.spacing = vm.units.spacing[vm.query.appRate.spacingDefault];

        // Set formula values
        var appRate = +(vm.query.appRate.value);
        var groundSpeed = +(vm.query.groundSpeed.value);
        var spacing = +(vm.query.spacing.value);
        var TORO_FORMULA_CONST = vm.query.appRate.formulaConstant;

        // Convert Km/H to MpH
        if (!vm.useMetricFormula && vm.query.groundSpeed.isMetric) {
          groundSpeed /= 1.6093;
        }

	// Concert MpH to Km/H
        if (vm.useMetricFormula && !vm.query.groundSpeed.isMetric) {
          groundSpeed /= 0.6213;
        }

        // Calculate using the formula that flow = (rate * speed * spacing) / CONST;
        var nozzleFlowRate = (appRate * groundSpeed * spacing) / TORO_FORMULA_CONST;

        vm.nozzleFlowRate = {
          unit: vm.useMetricFormula ? 'LpM' : 'GpM',
          value: nozzleFlowRate.toFixed(2)
        };

        if (scope.selectorOptions.mode.$valid) {
          filterNozzles(vm.nozzleFlowRate.unit, vm.nozzleFlowRate.value);
        }

        vm.calculated = true;
      } else {
        vm.calculated = false;
      }
    }

    function filterNozzles(unit, value) {
      unit = unit.toLowerCase();

      
      var nozzles = dataService.getNozzles();
      var cRanges = dataService.getColorRanges();
      var nozzleTypesMatrix = dataService.getNozzleTypesMatrix();

      var filtered = [];
      var inRangeOfColors = [];
      var color = '';
      var colorGpM = 0;

      var mode = vm.query.mode.toLowerCase();

      cRanges[unit].forEach(function(c) {
        if (value >= c.min && value <= c.max) {
          inRangeOfColors.push({
            color: c.color,
            perfect: c.perfect,
            diff: Math.abs(value - c.perfect)
          });
        }
      });

      if (inRangeOfColors.length < 1) {
        vm.disableResults = true;
      } else {
        vm.disableResults = false;

        // Nozzle Selection Algorithm - PART III (perfect spray pressure - PSI)
        if (inRangeOfColors.length > 1) {

          // Select the one color that is closest to the "perfect" spray pressure value
          var minDifference = Math.min.apply(Math, inRangeOfColors.map(function(o) {return o.diff;}));
          var preferredRange;

          inRangeOfColors.forEach(function(o) {
            if (o.diff === minDifference) {
              preferredRange = o;
            }
          });

          /* Example:
             nozzleFlowRate = 0.74 GpM
             colors = ['gray', 'white', 'blue']

             perfect for gray is 0.6
             perfect for white is 0.8,
             perfect for blue is 1

             0.74 is closest to 0.8, so we filter the white nozzles only (?)
          */
          color = preferredRange.color;
          colorGpM = preferredRange.perfect;
        } else {

          // it's in the range of only one color
          color = inRangeOfColors[0].color;
          colorGpM = inRangeOfColors[0].perfect;
        }

        vm.mode = vm.query.mode;
        vm.driftControl = vm.query.dc;

        filtered = nozzles[color];
      }

      // Join data
      var joinedNozzleData = filtered.joinWith(nozzleTypesMatrix, 'name', [
        'name', 'nameToTranslate', 'partNumber', 'image', 'strainer', 'mesh',
        'description', 'contact', 'systemic', 'driftControl'
      ]);

      // Filter by Drift Control & Nozzle Type
      var results = joinedNozzleData.map(function(n) {
        if (vm.query.dc) {

          // Show only the excellent/good ones for Drift Control when it's important
          // Show Excellent/Good ones if the Drift Control is important
          return (n.driftControl !== 'poor' && n[mode] !== 'poor') ? n : '';
        } else {

          // Filter only the excellent ones if the Drift Control is not important
          return n[mode] === 'excellent' ? n : '';
        }
      }).filter(Boolean);

      // Filter once more if the recommendations are more than two - this time filtering only the excellent ones
      // Use case: Systemic mode + drift control = too many results
      // Fixme: Code repeat, Todo: think about how to handle this more gracefully
      if (results.length > 2) {
        var excellent = joinedNozzleData.map(function(n) {
          if (vm.query.dc) {
            return (n.driftControl !== 'poor' && n[mode] === 'excellent') ? n : '';
          } else {
            return n[mode] === 'excellent' ? n : '';
          }
        }).filter(Boolean);

        results = excellent;
      }

      vm.colorGpM = colorGpM;
      vm.recommendedColor = color;
      vm.colors = [color];
      vm.meshes = results.length ? results[0].mesh : [];
      vm.results = results;

      return results;
    }

    function showResults(scope) {
      if (scope.selectorOptions.$valid) {
        $state.go('selector.results', { ready: true });
      } else {
        if (scope.selectorOptions.mode.$error) {

          // Scroll to the top
          window.scrollTo(0, 200);
        }
        console.log(scope.selectorOptions.$error);
      }
    }

    function goBack() {
      $state.go('selector');
    }

    function dismissWarning() {
      $localStorage.warned = true;
      vm.noemail.flag = true;
    }

    function generateEmailTemplate() {
      var to = 'someone@yoursite.com';
      var subject = $translate.instant('titles.recommended-nozzles');

      // translate labels
      var searchCriteria       = $translate.instant('titles.search-criteria');
      var applicationMode      = $translate.instant('titles.application-mode');
      var yes                  = $translate.instant('labels.yes');
      var no                   = $translate.instant('labels.no');
      var driftControl         = $translate.instant('nozzles.mode.drift-control');
      var applicationRate      = $translate.instant('labels.application-rate');
      var groundSpeed          = $translate.instant('labels.ground-speed');
      var calculatedFlowRate   = $translate.instant('labels.calculated-flow-rate');
      var recommendedNozzles   = $translate.instant('titles.recommended-nozzles');
      var recommendedFilters   = $translate.instant('titles.recommended-filter');
      var recommendedStrainer  = $translate.instant('titles.recommended-strainer');
      var nozzleOptions        = $translate.instant('email.nozzle-options');
      var recommendedColor     = $translate.instant('nozzles.colors.' + vm.recommendedColor);
      var tipStrainer          = $translate.instant('labels.tip-strainer');
      var partNumber           = $translate.instant('labels.part-number');
      var suctionFilter        = $translate.instant('email.suction-filter');
      var meshLabel            = $translate.instant('labels.mesh');

      var body = '' +
          searchCriteria + ':\n' +
          '        - ' + applicationMode + ': ' + vm.query.mode + '\n' +
          '        - ' + driftControl + ': ' + (vm.query.dc ? yes : no) + '\n' +
          '        - ' + applicationRate + ': ' + vm.query.appRate.value + ' ' + vm.appRate.abbr + '\n' +
          '        - ' + groundSpeed + ': ' + vm.query.groundSpeed.value + ' ' + vm.groundSpeed.abbr + '\n' +
          '        - ' + calculatedFlowRate + ' ' + vm.nozzleFlowRate.value + ' ' + vm.nozzleFlowRate.unit + '\n\n' +
          recommendedNozzles + ':\n' +
          '        - ' + applicationMode + ': ' + vm.query.mode + '\n';

      vm.results.forEach(function(nozzle) {
        var translatedNozzleName = $translate.instant(nozzle.nameToTranslate);
        var addition = nozzle.name != translatedNozzleName ?  ' (' + translatedNozzleName + ') ' : '';
        body +=  '        - ' + recommendedColor + ' ' + nozzle.name + addition + ', ' + partNumber + ' ' +
          nozzle.partNumber + '\n';
      });

      body += '\n' +
        recommendedFilters + ':\n' +
        '        - ' + partNumber + '  120-0699' + '\n\n' +
        recommendedStrainer + ':\n';

      vm.meshes.forEach(function(mesh) {
        body +=  '        - ' + meshLabel + ' ' + mesh + ', ' + partNumber + ' ' + vm.filters[mesh].partNumber + '\n';
      });

      vm.mailto = 'mailto:' + to + '?subject=' + subject + '&body=' +  window.encodeURIComponent(body);
    }
  }
}());
